<template>
  <div v-loading="allLoading" class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col w-20">
              <div class="das-form-input">
                <div class="label">Tên khóa</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.lockName"
                    type="text"
                    placeholder="Nhập tên khóa"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="das-form-col w-20">
                <div class="das-form-input">
                  <div class="label">Phòng</div>
                  <div class="child-w-80">
                    <input
                      v-model="searchParams.room_id"
                      type="text"
                      placeholder="Nhập mã phòng"
                    />
                  </div>
                </div>
              </div> -->
            <div class="das-form-col w-20">
              <div class="das-form-input">
                <div class="label"></div>
                <div class="child-w-80">
                  <div class="checkbox-wrap pr-1">
                    <input
                      id="isRoomBooking"
                      v-model="searchParams.isAssigned"
                      type="checkbox"
                    />
                    <label for="isRoomBooking">Đã được gán phòng</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="lockLoading" class="grid-scroll">
      <GridVx
        ref="lockTable"
        dom-layout="scroll"
        :columns="lockCols"
        :rows="lockRows"
        class="agGrid"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        @selectionChanged="onSelectLock"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="lockTable"
        :total-size="lockPaging.totalPage"
        :page-num="lockPaging.currentPage"
        @pageChanged="onPageChanged($event)"
        @onPageSizeChange="onPageSizeChanged($event)"
      />
    </div>
    <div class="button-containers">
      <div>
        <button
          v-if="searchParams.isAssigned === true"
          :disabled="lockRowSelected.length != 1 || disabledByLongTask"
          class="btn primary small loading-btn"
          @click="onOpenDialog"
        >
          <span v-if="disabledByLongTask" class="load"></span>
          Cập nhật phòng
        </button>
        <button
          v-if="searchParams.isAssigned === true"
          :disabled="lockRowSelected.length != 1 || disabledByLongTask"
          class="btn primary small outline ml-10 loading-btn"
          @click="onDeleteRoomOfLock"
        >
          <span v-if="disabledByLongTask" class="load"></span>
          Xóa gán phòng
        </button>
      </div>
      <button
        v-if="searchParams.isAssigned === false"
        :disabled="lockRowSelected.length != 1"
        class="btn primary small loading-btn"
        @click="onOpenDialog"
      >
        <span v-if="disabledByLongTask" class="load"></span>
        Gán khóa cho phòng
      </button>
      <!-- <button
        :disabled="lockRowSelected.length <= 0"
        class="btn primary small outline"
        @click="onDeleteLock"
      >
        Xóa khóa
      </button> -->
      <!-- Xóa khóa trên PMS sẽ cần phải reset lại khóa (do dữ liệu còn lưu trên khóa) -->
      <!-- Muốn xóa khỏi hệ thống dùng mobile app gốc -->
    </div>

    <!-- Room selection Dialog -->
    <el-dialog
      :title="`Gán khóa ${lockRowSelected[0]?.alias} cho phòng`"
      :visible.sync="dialogAssignLockToRoomVisible"
      :close-on-click-modal="false"
      width="70%"
      @closed="onCloseAssignLock"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-group-title">
              Danh sách phòng chưa gán khóa
            </div>
            <search-comp @onSearch="fnSearchRoomList" @onReset="onRoomReset">
              <div class="section-box">
                <div class="das-form-container">
                  <div class="das-form-group">
                    <div class="das-form-row">
                      <div class="das-form-col w-25">
                        <div class="das-form-input">
                          <div class="label">Số phòng</div>
                          <div class="child-w-80">
                            <input
                              v-model="roomSearchParams.roomNumber"
                              type="text"
                              placeholder="Nhập số phòng"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="das-form-col w-25">
                        <div class="das-form-input">
                          <div class="label">Khách sạn</div>
                          <div class="child-w-80">
                            <el-select
                              v-model="roomSearchParams.hotelId"
                              style="flex: 1"
                              placeholder="Chọn"
                            >
                              <el-option
                                v-for="(item, index) in hotelList"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="das-form-col w-25">
                        <div class="das-form-input">
                          <div class="label">Hạng phòng</div>
                          <div class="child-w-80">
                            <el-select
                              v-model="roomSearchParams.roomLevelId"
                              style="flex: 1"
                              placeholder="Chọn"
                            >
                              <el-option
                                v-for="(item, index) in roomLevelList"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </search-comp>
            <div class="section-box">
              <div class="das-form-container">
                <div
                  v-loading="roomLoading"
                  class="das-form-group"
                  style="height: 300px"
                >
                  <GridVx
                    ref="roomTable"
                    dom-layout="scroll"
                    :columns="roomColumns"
                    :rows="roomRows"
                    class="agGrid"
                    :auto-size-cell="true"
                    row-selection="single"
                    @selectionChanged="onSelectRoom"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            :disabled="selectedRoom == null"
            class="btn primary small"
            @click="
              () => {
                if (lockRowSelected[0]?.room_id) {
                  confirmUpdateRoomForLock()
                } else {
                  onAssignLockToRoom()
                }
              }
            "
          >
            Xác nhận
          </button>
          <button
            class="btn primary small outline"
            @click="dialogAssignLockToRoomVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLockList,
  deleteLock
} from '@/api/configuration/lockmanagement/lock'
import { getHotelListApi } from '@/api/booking_service/bookingGroup'
import { getListRoomApi } from '@/api/Room/room'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import {
  assignLockToRoom,
  updateRoomForLock
} from '@/api/configuration/lockmanagement/lock'
import { checkRunningTask } from '@/api/task'
export default {
  components: {},
  data() {
    return {
      dialogAssignLockToRoomVisible: false,
      lockRowSelected: [],

      allLoading: false,
      lockLoading: false,
      searchParams: {
        lockName: null,
        isAssigned: true,
        pageNum: 1,
        pageSize: 10
      },
      searchParamsDefault: {
        lockName: null,
        isAssigned: true,
        pageNum: 1,
        pageSize: 10
      },
      lockPaging: {
        totalPage: 0,
        currentPage: 0
      },
      lockRows: [],
      lockCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'STT',
          field: 'num',
          tooltipField: 'num',
          minWidth: 70,
          maxWidth: 80
        },
        {
          headerName: 'ID Khóa',
          field: 'lock_id',
          tooltipField: 'lock_id',
          minWidth: 100
        },
        {
          headerName: 'Tên khóa',
          field: 'alias',
          tooltipField: 'alias',
          minWidth: 100
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          minWidth: 100
        }
      ],
      lockId: null,
      disabledByLongTask: false,

      roomLoading: false,
      roomRows: [],
      roomColumns: [
        {
          headerName: 'Khách sạn',
          field: 'hotel_nm',
          minWidth: 100
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_name',
          minWidth: 100
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          minWidth: 100
        },
        {
          headerName: 'Thuộc tính phòng',
          field: 'property_names',
          minWidth: 400
        }
      ],
      roomSearchParams: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null
      },
      roomSearchParamsDefault: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null
      },
      roomLevelList: [],
      hotelList: [],
      selectedRoom: null
    }
  },

  watch: {
    'searchParams.isAssigned'(nv, ov) {
      this.onSearch()
    }
  },

  async mounted() {
    await this.onSearch()

    this.fnGetHotelListApi()
    this.getRoomLevelOptions()
  },

  methods: {
    async onSelectLock(select) {
      this.lockRowSelected = select
      if (select.length === 1) {
        this.disabledByLongTask = await checkRunningTask(
          select[0]?.lock_id,
          'LOCK'
        )
      } else {
        this.disabledByLongTask = false
      }
    },
    onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      this.fnGetLockList()
    },
    onPageSizeChanged(pageSize, field) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      this.fnGetLockList()
    },
    async fnGetLockList() {
      this.lockLoading = true
      await getLockList(this.searchParams)
        .then(res => {
          this.lockRows = res.data
          this.lockPaging.totalPage = Math.ceil(
            res.total / this.searchParams.pageSize
          )
          this.lockPaging.currentPage = this.searchParams.pageNum
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.lockLoading = false
        })
    },
    async onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      await this.onSearch()
    },
    async onSearch() {
      this.searchParams.pageNum = 1
      await this.fnGetLockList()
    },

    // delete room assigned to lock
    onDeleteRoomOfLock() {
      this.$vxConfirm(
        `Bạn có chắc chắn muốn xóa khóa ${this.lockRowSelected[0]?.alias} khỏi phòng ${this.lockRowSelected[0]?.room_num}`,
        {
          title: 'Xóa gán phòng',
          resolveText: 'Xác nhận',
          rejectText: 'Đóng',
          resolve: () => this.confirmDeleteRoomOfLock()
        }
      )
    },
    confirmDeleteRoomOfLock() {
      this.allLoading = true
      updateRoomForLock({
        oldRoomId: this.lockRowSelected[0]?.room_id,
        newRoomId: null,
        lockId: this.lockRowSelected[0]?.lock_id
      })
        .then(res => {
          if (!res?.is_error) {
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${res.message}`)
            })
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.allLoading = false
          this.selectedRoom = null
          this.lockRowSelected = []
          this.onSearch()
        })
    },

    // delete lock
    onDeleteLock() {
      this.$vxConfirm(
        'Bạn chắc chắn muốn xóa khóa từ này? Sau khi xóa, dữ liệu của khóa sẽ không thể sử dụng nữa !',
        {
          title: 'Xóa khóa',
          resolveText: 'Xác nhận',
          rejectText: 'Đóng',
          resolve: () => this.confirmDeleteLock()
        }
      )
    },
    async confirmDeleteLock() {
      this.allLoading = true
      await deleteLock({
        idList: this.lockRowSelected.map(item => item.lock_id)
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${res.message}`)
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.allLoading = false
          this.selectedRoom = null
          this.lockRowSelected = []
          this.onSearch()
        })
    },

    // ==================== POPUP: room selection and submit
    async fnGetHotelListApi() {
      const data = await getHotelListApi()
      this.hotelList = data?.data || null
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
    },
    // free room (not assigned lock)
    async fnSearchRoomList() {
      this.roomLoading = true
      var params = {
        ...this.roomSearchParams,
        isAssignLock: false
      }
      await getListRoomApi(params)
        .then(res => {
          this.roomRows = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.roomLoading = false
        })
    },
    onRoomReset() {
      this.roomSearchParams = Object.assign({}, this.roomSearchParamsDefault)
      this.fnSearchRoomList()
    },
    async onOpenDialog() {
      await this.fnSearchRoomList()
      this.dialogAssignLockToRoomVisible = true
    },
    onCloseAssignLock() {
      this.selectedRoom = null
      this.dialogAssignLockToRoomVisible = false
    },
    onSelectRoom(select) {
      this.selectedRoom = select[0] || null
    },
    confirmUpdateRoomForLock() {
      this.$vxConfirm(
        'Bạn chắc chắn muốn thay đổi phòng cho khóa này? Dữ liệu của khóa sẽ không thể sử dụng nữa !',
        {
          title: 'Xóa khóa',
          resolveText: 'Xác nhận',
          rejectText: 'Đóng',
          resolve: () => this.onAssignLockToRoom()
        }
      )
    },
    onAssignLockToRoom() {
      this.allLoading = true
      const data = {
        room_id: this.selectedRoom.id,
        lock_id: this.lockRowSelected[0].lock_id
      }
      const params = {
        oldRoomId: this.lockRowSelected[0]?.room_id,
        newRoomId: this.selectedRoom.id,
        lockId: this.lockRowSelected[0]?.lock_id
      }
      let promise
      if (!params.oldRoomId) {
        promise = assignLockToRoom(data)
      } else {
        promise = updateRoomForLock(params)
      }
      promise
        .then(res => {
          if (!res?.is_error) {
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${res.message}`)
            })
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.dialogAssignLockToRoomVisible = false
          this.roomSearchParams = Object.assign({}, this.searchParamsDefault)

          this.allLoading = false
          this.selectedRoom = null
          this.lockRowSelected = []
          this.onSearch()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.w-20 {
  width: 20%;
}
.mt-10 {
  margin-top: 40px;
}
</style>
